import { render } from "./TeacherScheduling.vue?vue&type=template&id=423be694&scoped=true"
import script from "./TeacherScheduling.vue?vue&type=script&lang=js"
export * from "./TeacherScheduling.vue?vue&type=script&lang=js"

import "./TeacherScheduling.vue?vue&type=style&index=0&id=423be694&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423be694"]])

export default __exports__